<template>
  <div>
    <div
      v-if="noData"
      class="nowzb-wrapper"
      :style="{height:Height+'px',backgroundSize:'100% '+Height+'px'}"
    >
      <div class="nodata">
        暂无微支部
      </div>
    </div>
    <div v-else>
      <Carousel
        v-if="isReload"
        :style="{width:Width+'px',height: Height+'px'}"
        @on-change="changeInd"
        v-model="startInd"
        arrow="never"
        autoplay
        :autoplay-speed="autoplaySpeed"
        dots="none"
      >
        <CarouselItem v-for="(item, index) in orgList" :key="index">
          <div
            :style="{height:Height+'px',backgroundSize:'100% '+Height+'px'}"
            class="wzb-wrapper box"
          >
            <!--微支部头部-->
            <div class="box wzb-header" :style="{top:Height*0.029+'px'}">
              <img src="@/assets/images/partyDetail/flag.png" style="height:84px;width: 94px"
                   :style="{height:Width>1300?'84px':'65px',width: Width>1300?'94px':'65px'}">
              <div class="wzb-title" :style="{fontSize:Width>1300?'55px':'45px'}">{{item.name}}</div>
            </div>
            <!--//微支部主体-->
            <wzb-left
              :height="Height"
              :width="Width"
              :info="info"
              :leftScroll="leftScroll"
            ></wzb-left>
            <wzb-mid
              :height="Height"
              class="box_f1"
              :width="Width"
              :manager="manager"
              :leader="leader"
              :huodongNumber="huodongNumber"
              :qiandaoNumber="qiandaoNumber"
              :activityPicList="activityPicList"
              :index="index"
              :nowIndex="nowIndex"
            ></wzb-mid>
            <wzb-right
              :height="Height"
              :width="Width"
              :partyActive="partyActive"
              :baomingMember="baomingMember"
            ></wzb-right>
          </div>
        </CarouselItem>
      </Carousel>
    </div>

  </div>
</template>

<script>
  import wzbLeft from './components/wzbLeft'
  import wzbRight from './components/wzbRight'
  import wzbMid from './components/wzbMiddle'
  var that
  export default {
    inject: ['reload'],
    components: {
      wzbLeft,
      wzbRight,
      wzbMid
    },
    data() {
      return {
        Height: window.document.body.offsetHeight - 60,
        Width: window.document.body.offsetWidth,
        autoplaySpeed: 10000,
        orgList: [],
        startInd: 0, // 默认起始微支部索引
        nowIndex: 0, //当前页面Index,
        info: {
          remark: "",
          totalNumber: 0,
          zoneId: 0,
          zoneName: "",
          qrcodeUrl: ""
        }, // 微支部或微社区的基本信息
        leader: [], // 委员
        manager: {
          headPicUrl: "",
          realName: "",
          unionId: ""
        }, // 管理员
        leftScroll: [], //支部详情 简介以及图片
        huodongNumber: 0, //活动数量
        qiandaoNumber: 0, //签到数量
        partyActive: {}, //支部活动
        activityPicList: [], //活动图片
        baomingMember: [], //报名人集合
        noData: false,
        isReload: true
      }

    },
    computed: {},
    mounted: function () {
      that = this
      window.addEventListener('resize', this.handleResize)
      this.Height = window.document.body.offsetHeight - 60
      this.Width = window.document.body.offsetWidth;
      if (this.Height < 788) {
        this.Height = 788
      }
      this.getWzbList();
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize(event) {
        this.isReload = false
        this.Width = window.document.body.offsetWidth
        this.Height = document.documentElement.clientHeight - 60;
        if (this.Height < 700) {
          this.Height = 700;
        }
        if (this.Width < 1300) {
          this.Width = 1300
        }
        this.$nextTick(() => {
          this.isReload = true
        })
      },
      getWzbList() {
        var url = this.urlobj.getOrg();
        this.$get(url, {
          communityId: that.$store.state.streetorcommunityid,
          zoneType: 2
        }).then(res => {
          if (res.rows.length > 0) {
            that.noData = false;
            that.orgList = res.rows.map(item => {
              return {
                name: item.zoneName,
                id: item.zoneId
              };
            });
            var id = that.orgList[0].id;
            that.promiseData(id);
          } else {
            that.$store.commit("updateSpinShow", false);
            that.noData = true;
          }
        });
      },
      promiseData(id) {
        that.loading = true
        var getSqDetail = that.getSqDetail(id);
        var getEvent = that.getEvent(id);
        Promise.all([getSqDetail, getEvent]).then(res => {
          // console.log(res);
          that.$store.commit("updateSpinShow", false);
          that.loading = false
          //处理getSqDetail的数据
          let _t = res[0].rows[0];
          // 初始化info
          this.info = {
            totalNumber: _t.info.totalNumber,
            zoneName: _t.info.zoneName,
            qrcodeUrl: _t.info.qrcodeUrl
          };
          // 初始化图片
          var imgArr = [];
          _t.pic.map(item => {
            imgArr.push({img: item.picPath});
          });
          this.leftScroll = [
            {text: _t.info.remark ? _t.info.remark : ""}
          ].concat(imgArr);
          // 初始化管理员
          this.manager = {
            headPicUrl: _t.manager.length > 0 ? _t.manager[0].headPicUrl : "",
            realName: _t.manager.length > 0 ? _t.manager[0].realName : "",
            unionId: _t.manager.length > 0 ? _t.manager[0].unionId : ""
          };
          // 初始化 委员
          this.leader = _t.leader.map(item => {
            return {
              id: item.id,
              headPicUrl: item.headPicUrl,
              proTitle: item.proTitle,
              realName: item.realName,
              unionId: item.unionId
            };
          });
          //活动 签到数量
          that.huodongNumber = _t.activityCount.activityCount;
          that.qiandaoNumber = _t.activityCount.signCount;

          //处理getEvent 的数据
          var data = res[1];
          if (data.rows.length) {
            that.activityPicList = data.rows[0].activityPicList;
            var req = data.rows[0].detail;
            that.partyActive = {
              title: req.title,
              baoming: req.applyNumber,
              pinglun: req.messageNumber,
              chakan: req.previewNumber,
              cover: req.coverPicUrl
            };
            that.baomingMember = data.rows[0].applyUserList
              .splice(0, 4)
              .map(item => {
                return {
                  pic: item.headPicUrl,
                  name: item.userName,
                  time:
                    typeof item.recordTime == "string"
                      ? item.recordTime
                      : that.$util.FormatDate(
                      Number(item.recordTime),
                      "MM-dd  HH:mm"
                      )
                };
              });
          } else {
            that.partyActive = {
              title: "",
              baoming: "",
              pinglun: "",
              chakan: "",
              cover: "",

            };
            that.baomingMember = [];
            that.activityPicList = []
          }
        });
      },
      getSqDetail(id) {
        return new Promise((resolve, reject) => {
          let url = this.urlobj.zoneInfo(id);
          this.$get(url)
            .then(res => {
              if (res.isSucceed) {
                resolve(res);
              }
            })
            .catch(e => reject(e));
        });
      },
      getEvent(id) {
        return new Promise((resolve, reject) => {
          var url = this.urlobj.getPartyActive;
          this.$get(url, {
            zoneId: id
          })
            .then(res => {
              resolve(res);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      changeInd(oldValue, value) {
        this.nowIndex = value;
        this.initData()
        that.promiseData(that.orgList[value].id);
      },
      initData() {
        this.info = {
          remark: "",
          totalNumber: 0,
          zoneId: 0,
          zoneName: "",
          qrcodeUrl: ""
        } // 微支部或微社区的基本信息
        this.leader = [] // 委员
        this.manager = {
          headPicUrl: "",
          realName: "",
          unionId: ""
        } // 管理员
        this.leftScroll = [] //支部详情 简介以及图片
        this.huodongNumber = 0 //活动数量
        this.qiandaoNumber = 0 //签到数量
        this.partyActive = {}//支部活动
        this.activityPicList = [] //活动图片
        this.baomingMember = [] //报名人集合
      }
    },
  }
</script>

<style scoped>
  .nowzb-wrapper {
    position: relative;
    background-image: url("../../assets/staticsPic/bc.png");
    background-repeat: no-repeat;
  }
  .nodata {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ddd;
    font-size: 50px;
  }
  .wzb-wrapper {
    position: relative;
    padding-top: 6.25%;
    background-image: url("../../assets/staticsPic/bc.png");
    background-repeat: no-repeat;
  }

  .wzb-header {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    vertical-align: top;
    white-space: nowrap
  }

  .wzb-title {
    font-family: 'KaiTi';
    font-size: 55px;
    margin-top: -15px;
    margin-left: 10px;
    background-image: url('../../assets/images/partyDetail/orgTitleBg.jpg');
    background-repeat: repeat-x;
    color: transparent;
    -webkit-background-clip: text;
    white-space: nowrap;
    max-width: 1000px;
    overflow: hidden;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .margin-all {
    margin: 17.5px
  }

  .margin-top {
    margin-top: 17.5px
  }

  .margin-bottom {
    margin-bottom: 17.5px;
  }

  .margin-left {
    margin-left: 17.5px;
  }

  .margin-right {
    margin-right: 17.5px;
  }

  .box-btw {
    justify-content: space-between
  }
</style>
